// extracted by mini-css-extract-plugin
export default {"left-nav":"left-nav__CUe95mYrB1Ab"};